// SP 下部固定ナビ — ヘッダーのドロワー / 検索モーダル（details-modal）を再利用

const MOBILE_BOTTOM_NAV_QUERY = '(max-width: 999px)';

const getHeaderSearchModal = () =>
  document.querySelector('.cm-header .header__icons details-modal.header__search') ||
  document.querySelector('.cm-header details-modal.header__search');

const syncMobileCartBubble = () => {
  const sourceBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
  const targetWrap = document.querySelector('[data-cm-mobile-nav-cart-bubble]');

  if (!targetWrap) return;

  if (sourceBubble) {
    targetWrap.innerHTML = sourceBubble.outerHTML;
    return;
  }

  targetWrap.innerHTML = '';
};

const syncMobileMenuIcon = () => {
  const details = document.querySelector('#Details-menu-drawer-container');
  const menuButton = document.querySelector('[data-cm-mobile-nav="menu"]');

  if (!details || !menuButton) return;

  const isOpen = details.hasAttribute('open');

  menuButton.classList.toggle('is-menu-drawer-open', isOpen);
  menuButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  menuButton.setAttribute(
    'aria-label',
    isOpen ? menuButton.dataset.closeLabel || 'Close' : menuButton.dataset.menuLabel || 'Menu'
  );
};

const syncMobileSearchIcon = () => {
  const modal = getHeaderSearchModal();
  const searchButton = document.querySelector('[data-cm-mobile-nav="search"]');

  if (!modal || !searchButton) return;

  const isOpen = modal.isOpen?.() ?? false;

  searchButton.classList.toggle('is-search-open', isOpen);
  searchButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  searchButton.setAttribute(
    'aria-label',
    isOpen ? searchButton.dataset.closeLabel || 'Close' : searchButton.dataset.searchLabel || 'Search'
  );

  document.documentElement.classList.toggle('is-mobile-search-open', isOpen);

  if (!window.matchMedia(MOBILE_BOTTOM_NAV_QUERY).matches) return;

  document.querySelectorAll('.cm-newsletter-popup__trigger, cm-back-to-top').forEach((element) => {
    element.toggleAttribute('hidden', isOpen);
  });
};

const closeMobileMenuDrawerIfOpen = () => {
  const headerDrawer = document.querySelector('header-drawer');
  const details = document.querySelector('#Details-menu-drawer-container');
  const summary = details?.querySelector('summary');

  if (!details?.hasAttribute('open') || !headerDrawer || !summary) return;

  headerDrawer.closeMenuDrawer(new Event('click'), summary);
};

const closeMobileSearchIfOpen = () => {
  const modal = getHeaderSearchModal();

  if (!modal?.isOpen?.()) return;

  modal.close(false);
};

const openMobileMenuDrawer = () => {
  const headerDrawer = document.querySelector('header-drawer');
  const details = document.querySelector('#Details-menu-drawer-container');
  const summary = details?.querySelector('summary');

  if (!headerDrawer || !details || !summary) return;

  if (details.hasAttribute('open')) {
    headerDrawer.closeMenuDrawer(new Event('click'), summary);
    return;
  }

  closeMobileSearchIfOpen();
  details.setAttribute('open', '');
  headerDrawer.openMenuDrawer(summary);
};

const closeNewsletterPopupIfOpen = () => {
  document.querySelector('.cm-newsletter-popup__dialog[open]')?.close();
};

const openMobileSearch = () => {
  if (!window.matchMedia(MOBILE_BOTTOM_NAV_QUERY).matches) return;

  const modal = getHeaderSearchModal();
  const summary = modal?.querySelector('summary');

  if (!modal || !summary) return;

  if (modal.isOpen?.()) {
    modal.close(false);
    return;
  }

  closeMobileMenuDrawerIfOpen();
  closeNewsletterPopupIfOpen();
  modal.open({ target: summary });
};

const initMobileBottomNav = () => {
  const nav = document.querySelector('[data-cm-mobile-bottom-nav]');
  if (!nav) return;

  nav.querySelector('[data-cm-mobile-nav="menu"]')?.addEventListener('click', openMobileMenuDrawer);
  nav.querySelector('[data-cm-mobile-nav="search"]')?.addEventListener('click', (event) => {
    event.stopPropagation();
    openMobileSearch();
  });

  const menuDrawerDetails = document.querySelector('#Details-menu-drawer-container');
  menuDrawerDetails?.addEventListener('toggle', syncMobileMenuIcon);
  syncMobileMenuIcon();

  const searchDetails = getHeaderSearchModal()?.querySelector('details');
  searchDetails?.addEventListener('toggle', syncMobileSearchIcon);
  syncMobileSearchIcon();

  syncMobileCartBubble();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncMobileCartBubble);
  }

  const cartIcon = document.querySelector('#cart-icon-bubble');
  if (cartIcon && typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(syncMobileCartBubble);
    observer.observe(cartIcon, { childList: true, subtree: true });
  }
};

const updateMobileBottomNavVisibility = () => {
  const nav = document.querySelector('[data-cm-mobile-bottom-nav]');
  if (!nav) return;

  const isMobile = window.matchMedia(MOBILE_BOTTOM_NAV_QUERY).matches;
  document.documentElement.classList.toggle('has-mobile-bottom-nav', isMobile);

  if (!isMobile) {
    closeMobileSearchIfOpen();
  }
};

document.addEventListener('DOMContentLoaded', () => {
  initMobileBottomNav();
  updateMobileBottomNavVisibility();
  window.matchMedia(MOBILE_BOTTOM_NAV_QUERY).addEventListener('change', updateMobileBottomNavVisibility);
});
